/*============================================================================
Show Collection Image in Nav
==============================================================================
function navImageAnimation() {
    if ( $(window).width() >= 1385 ) {
        for ( var i = 1; i < 10; i++ ) {
            var imageContainer = '.image-li-container-' + i;
            $(imageContainer).each(function() {
                $(this).hover(function() {
                    $('.nav-bar').addClass('nav-bar-hover');
                    $(this).children().first().toggleClass('collection-link-container-hover');
                    $(this).siblings().removeClass('link-image-show');
                    $(this).next().addClass('link-image-show');
                });
                $(this).mouseleave(function() {
                    $(this).next().removeClass('link-image-show');
                    $('.nav-bar').removeClass('nav-bar-hover');
                });
                if ( imageContainer == '.image-li-container-3') {
                    $(this).hover(function() {
                        $('.link-text-container-3').css('display', 'inline-block');
                    });
                    $(this).mouseleave(function() {
                        $('.link-text-container-3').css('display', 'none');
                    });
                };
            });
        };
    } else {
        for ( var i = 1; i < 10; i++ ) {
            var imageContainer = '.image-li-container-' + i;
            $(imageContainer).each(function() {
                $(this).hover(function() {
                    $('.nav-bar').removeClass('nav-bar-hover');
                    $(this).children().first().removeClass('collection-link-container-hover');
                    $(this).siblings().removeClass('link-image-show');
                });
                if ( imageContainer == '.image-li-container-3') {
                    $(this).hover(function() {
                        $('.link-text-container-3').css('display', 'none');
                    });
                };
            });
        };
    }
}

navImageAnimation();

$(window).on('resize', function() {
    navImageAnimation();
});
*/

/*============================================================================
Animate Social Icons
==============================================================================*/
$('.social-icons img').hover(function() {
  $(this).toggleClass('animated jello');
});

/*============================================================================
 Nav fade in
==============================================================================*/
$(document).ready(function() {
    window.setTimeout(function() {
        $('.template-index .nav-bar').css('opacity', '1');
    }, 1000);
});


/*============================================================================
 Instagram Plugin // Spectragram
==============================================================================*/
jQuery.fn.spectragram.accessData = {
    accessToken: '1937653665.61ec66e.d31cffed11bb45f7a457881eb2e42f8e',
    clientID: '61ec66e023ef495a9b18e5a41b2b2508'
};

$('#instagram').spectragram('getUserFeed',{
    query: 'mountainprimal',
    max: 5,
    wrapEachWith: '<div class="instagram-image-container grid__item small--one-third medium--one-third large--one-fifth position-relative"></div>'
});


$(window).on('load',function(){
    instagram_image_background();
});

instagram_image_background = function() {
    $(".instagram-image-container img").each(function(i, elem) {
      var img = $(elem);
      var div = $("<div />").css({
        background: "url(" + img.attr("src") + ") no-repeat center center / cover",
        width: img.width() + "px",
        height: img.height() + "px"
      });

      if ( img.height() <= 212 ) {
          div.css({
              width: img.width() + 120 + "px",
              height: img.height() + 120 + "px"
          });
      };

      div.addClass('instagram-image');
      div.html(img.attr("alt"));

      img.replaceWith(div);
    });

    $('.instagram-image-container div').each(function(){
        $(this).html("");
    });

    $('.instagram-image-container a').append('<div class="instagram-overlay-container"><div class="position-relative"><span class="instagram-info-container"><i class="fa fa-instagram"></i><p class="instagram-caption"></p></span></div></div>');

    window.setTimeout(function(){
        $('.instagram-container').css('opacity', '1');
    }, 500);

    $('.instagram-overlay-container').each(function() {
        var titleText = $(this).parent().attr('title');
        $(this).children().children().children().last().html(titleText);
        $(this).hover(function() {
            $(this).children().children().toggle();
        });
    });
};


/*============================================================================
Hover Effect on 'From The Blog'
==============================================================================*/
$('.blog-link-a').each(function(){
    $(this).hover(function(){
        $(this).next().toggleClass('hover-effect');
    });
});


/*============================================================================
Equal Height Divs
==============================================================================*/
/* Thanks to CSS Tricks for pointing out this bit of jQuery
http://css-tricks.com/equal-height-blocks-in-rows/
It's been modified into a function called at page load and then each time the page is resized. One large modification was to remove the set height before each new calculation. */

equalheight = function(container){

var currentTallest = 0,
     currentRowStart = 0,
     rowDivs = new Array(),
     $el,
     topPosition = 0;
 $(container).each(function() {

   $el = $(this);
   $($el).height('auto')
   topPostion = $el.position().top;

   if (currentRowStart != topPostion) {
     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
       rowDivs[currentDiv].height(currentTallest);
     }
     rowDivs.length = 0; // empty the array
     currentRowStart = topPostion;
     currentTallest = $el.height();
     rowDivs.push($el);
   } else {
     rowDivs.push($el);
     currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
  }
   for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
     rowDivs[currentDiv].height(currentTallest);
   }
 });
};


$(window).load(function() {
  equalheight('.same_height');
});

$(window).resize(function(){
  equalheight('.same_height');
});

/*============================================================================
Hero Slick Carousel
==============================================================================*/
$('#Hero').slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    nextArrow: '#slideshow .arrows-container .right',
    prevArrow: '#slideshow .arrows-container .left'
});


/*============================================================================
Testimonials Slick Carousel
==============================================================================*/
$('#testimonial-hero').slick({
    dots: false,
    infinite: true,
    slidesToShow: 3,
    nextArrow: '#testimonials .arrows-container .right',
    prevArrow: '#testimonials .arrows-container .left'
});


/*============================================================================
Home Page Collection Slick Carousel
==============================================================================*/
$('#collection-grid').slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    autoplay: true,
    autoplaySpeed: 4000,
    nextArrow: '#shopify-section-1513811742073 .arrows-container .right',
    prevArrow: '#shopify-section-1513811742073 .arrows-container .left',
    responsive: [
    {
       breakpoint: 1100,
       settings: {
           slidesToShow: 4,
       }
    },
    {
       breakpoint: 1090,
       settings: {
           slidesToShow: 3,
       }
    },
    {
       breakpoint: 900,
       settings: {
           slidesToShow: 2,
       }
    },
   {
       breakpoint: 640,
       settings: {
           slidesToShow: 1,
       }
   }
 ]
});


/*============================================================================
Related Products Carousel
==============================================================================*/
$('.related-products-carousel-container .container').slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    nextArrow: '.fa-caret-right',
    prevArrow: '.fa-caret-left',
    responsive: [
    {
       breakpoint: 1160,
       settings: {
           slidesToShow: 3,
       }
    },
    {
       breakpoint: 900,
       settings: {
           slidesToShow: 2,
       }
    },
   {
       breakpoint: 640,
       settings: {
           slidesToShow: 1,
       }
   }
 ]
});


/*============================================================================
Featured Products Carousel
==============================================================================
$('#CollectionSection .container').slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    nextArrow: '.fa-caret-right',
    prevArrow: '.fa-caret-left',
    responsive: [
    {
       breakpoint: 1100,
       settings: {
           slidesToShow: 4,
       }
    },
    {
       breakpoint: 1090,
       settings: {
           slidesToShow: 3,
       }
    },
    {
       breakpoint: 900,
       settings: {
           slidesToShow: 2,
       }
    },
   {
       breakpoint: 640,
       settings: {
           slidesToShow: 1,
       }
   }
 ]
});
*/


/*============================================================================
Tabs on Product page
==============================================================================*/
$(document).ready(function() {
    $('ul.tabs').each(function(){
        var active, content, links = $(this).find('a');
        active = links.first().addClass('active');
        content = $(active.attr('href'));
        links.not(':first').each(function () {
            $($(this).attr('href')).hide();
        });

        $(this).find('a').click(function(e){
            active.removeClass('active');
            content.hide();
            active = $(this);
            content = $($(this).attr('href'));
            active.addClass('active');
            content.show();
            return false;
        });
    });
});